module.exports = __webpack_public_path__ + "img/behaviour-3-mobile.a8026e41.gif";